import { render, staticRenderFns } from "./CamaraVODPantalla.vue?vue&type=template&id=9cda66da&scoped=true&"
import script from "./CamaraVODPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraVODPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cda66da",
  null
  
)

export default component.exports